/* STEP 2 · agent s2a3 — A3 (the attachment drop-zone words) and A5 (Refresh now while a firm refresh is running). EN + AR.
   Loaded from lib/i18n/ by the generated index (STEP 2 · B2). */
export const I18N_S2A3 = {
  en: {
    s2a3: {
      dropOr: "Drag & drop files here, or",
      browse: "browse",
      refreshAlreadyRunning: "Refresh already running — the figures update in the background",
    },
  },
  ar: {
    s2a3: {
      dropOr: "اسحب الملفات وأفلتها هنا، أو",
      browse: "تصفّح",
      refreshAlreadyRunning: "التحديث قيد التشغيل بالفعل — تُحدَّث الأرقام في الخلفية",
    },
  },
};

export default I18N_S2A3;
